import { createContext, useContext, useState } from "react";

const translations = {
  en: {
    "nav.solutions": "Solutions",
    "nav.markets": "Markets",
    "nav.about": "About",
    "nav.login": "Client Login",
    "nav.openAccount": "Open an Account",
    "nav.dashboard": "My Dashboard",
    "hero.badge": "Private Crypto Wealth · Institutional Execution Desk",
    "hero.titleA": "Private crypto wealth,",
    "hero.titleB": "engineered like an institution.",
    "hero.subtitle":
      "UCP combines Swiss private-banking discipline with real-time digital asset execution. Live Binance market data, dedicated desk supervision, and tailored accumulation strategies — inside one confidential client space.",
    "hero.ctaPrimary": "Request Access",
    "hero.ctaSecondary": "Explore Solutions",
    "hero.liveLabel": "Live market feed",
    "trust.aum": "Assets under advisory",
    "trust.uptime": "Market data uptime",
    "trust.cold": "Cold storage coverage",
    "trust.clients": "Private clients onboarded",
    "solutions.eyebrow": "Investment Solutions",
    "solutions.title": "Strategies built for digital assets",
    "solutions.subtitle":
      "Inspired by private-banking portfolio construction, adapted to crypto markets. Each mandate is executed and supervised by the UCP desk.",
    "solutions.dca.title": "DCA Accumulation",
    "solutions.dca.desc":
      "Dollar Cost Averaging smooths entry prices by deploying fixed amounts at fixed intervals — regardless of market direction.",
    "solutions.dca.b1": "Weekly or monthly scheduled allocations",
    "solutions.dca.b2": "Automatic execution on BTC, ETH and stablecoin pairs",
    "solutions.dca.b3": "Volatility harvesting: more units bought when prices fall",
    "solutions.yield.title": "Yield Generation",
    "solutions.yield.desc":
      "Stablecoin treasury strategies targeting consistent carry, with strict counterparty and network controls.",
    "solutions.yield.b1": "USDT / USDC structured carry positions",
    "solutions.yield.b2": "Network-diversified settlement (Base, ERC-20, TRC-20)",
    "solutions.yield.b3": "Monthly reporting with full audit trail",
    "solutions.arb.title": "High-Frequency Arbitrage",
    "solutions.arb.desc":
      "Cross-venue price dislocations captured by our execution infrastructure, monitored around the clock.",
    "solutions.arb.b1": "Sub-second spread detection across venues",
    "solutions.arb.b2": "Delta-neutral exposure — no directional risk",
    "solutions.arb.b3": "Desk-validated settlement on every cycle",
    "solutions.wealth.title": "Tailored Wealth Mandates",
    "solutions.wealth.desc":
      "A dedicated advisor builds a bespoke digital-asset allocation aligned with your global wealth objectives.",
    "solutions.wealth.b1": "Discretionary or advisory mandates",
    "solutions.wealth.b2": "SEPA & multi-network funding rails",
    "solutions.wealth.b3": "Confidential quarterly reviews",
    "math.eyebrow": "The Mathematics of DCA",
    "math.title": "Why disciplined accumulation beats timing",
    "math.formulaLabel": "Average acquisition cost",
    "math.formula": "P̄ = Σ Aᵢ / Σ (Aᵢ / Pᵢ)",
    "math.formulaHint":
      "Where Aᵢ is the amount invested at period i and Pᵢ the market price. The harmonic mean of prices means you automatically buy more units when prices are low.",
    "math.exampleTitle": "Illustration — $1,000 per month over 4 months",
    "math.colMonth": "Month",
    "math.colPrice": "BTC price",
    "math.colUnits": "Units acquired",
    "math.avg": "Your average cost",
    "math.last": "Last price",
    "math.result":
      "The average cost sits below the arithmetic mean of prices — the mathematical edge of DCA.",
    "markets.eyebrow": "Live Markets",
    "markets.title": "Real-time prices, straight from Binance",
    "markets.subtitle": "Streaming quotes on the 10 most traded digital assets.",
    "markets.asset": "Asset",
    "markets.price": "Price",
    "markets.change": "24h Change",
    "markets.high": "24h High",
    "markets.low": "24h Low",
    "markets.volume": "Volume (USDT)",
    "about.eyebrow": "The UCP Standard",
    "about.title": "Private banking rigour, crypto-native execution",
    "about.body":
      "Every client relationship is supervised by the UCP desk. Deposits, withdrawals and trades are individually reviewed and validated — combining institutional compliance workflows with the speed of digital assets.",
    "about.point1": "Desk-validated transactions",
    "about.point1d": "No movement is executed without administrative validation.",
    "about.point2": "Confidential client space",
    "about.point2d": "Access is granted only after identity review by our team.",
    "about.point3": "Institutional reporting",
    "about.point3d": "Full trade history, connection audit trail and exportable records.",
    "cta.title": "Open your private client space",
    "cta.subtitle":
      "Registration is reviewed by the UCP desk. Once validated, your full trading environment is unlocked.",
    "cta.button": "Create my account",
    "footer.tagline":
      "Private wealth management and institutional-grade digital asset execution, reserved for a confidential circle of clients.",
    "footer.legalTitle": "Legal",
    "footer.contactTitle": "Contact",
    "footer.cgv": "Terms of Sale (CGV)",
    "footer.cgu": "Terms of Use (CGU)",
    "footer.privacy": "Privacy Policy & GDPR",
    "footer.cookies": "Cookie Policy",
    "footer.rights": "All rights reserved.",
    "cookies.title": "Your privacy matters",
    "cookies.body":
      "We use essential cookies for authentication and security, and optional cookies to improve your experience. You can accept or decline non-essential cookies.",
    "cookies.accept": "Accept all",
    "cookies.decline": "Essential only",
    "cookies.learn": "Learn more",
    "auth.loginTitle": "Client Login",
    "auth.loginSubtitle": "Access your private trading space.",
    "auth.identifier": "Email or login",
    "auth.password": "Password",
    "auth.loginBtn": "Sign in",
    "auth.noAccount": "No account yet?",
    "auth.createOne": "Request access",
    "auth.registerTitle": "Open an Account",
    "auth.registerSubtitle":
      "Your registration will be reviewed by the UCP desk before full access is granted.",
    "auth.fullName": "Full name",
    "auth.email": "Email address",
    "auth.phone": "Phone number",
    "auth.confirm": "Confirm password",
    "auth.registerBtn": "Submit my application",
    "auth.hasAccount": "Already registered?",
    "auth.acceptCgu": "I accept the Terms of Use and the Privacy Policy",
    "auth.pendingTitle": "Application under review",
    "auth.pendingBody":
      "Thank you. Your registration is being reviewed by the UCP desk. You will receive access to your full dashboard once your account is validated.",
    "auth.mismatch": "Passwords do not match",
    "auth.mustAccept": "Please accept the Terms of Use",
    "dash.overview": "Overview",
    "dash.trading": "Trading",
    "dash.funding": "Funding & Wallets",
    "dash.history": "History",
    "dash.totalValue": "Total portfolio value",
    "dash.cash": "Available cash (USD)",
    "dash.btcEq": "BTC equivalent",
    "dash.logout": "Sign out",
    "dash.pendingGateTitle": "Account pending validation",
    "dash.pendingGateBody":
      "Your application has been received. The UCP desk is reviewing your profile — your full trading dashboard will unlock once validated. No action is required from you.",
    "dash.rejectedGateTitle": "Application not approved",
    "dash.rejectedGateBody":
      "Your application could not be approved at this time. Please contact the desk for more information.",
    "dash.suspendedGateTitle": "Account suspended",
    "dash.suspendedGateBody":
      "Your account is temporarily suspended. Please contact the UCP desk.",
    "dash.tradeTicket": "Trade Ticket",
    "dash.buy": "Buy",
    "dash.sell": "Sell",
    "dash.amount": "Amount (USD)",
    "dash.submitTrade": "Submit trade",
    "dash.tradeSent": "Trade submitted — pending desk validation",
    "dash.pendingBadge": "Pending",
    "dash.executedBadge": "Executed",
    "dash.rejectedBadge": "Rejected",
    "dash.validatedBadge": "Validated",
    "dash.recentTrades": "Trade history",
    "dash.allocTitle": "Asset allocation",
    "dash.addBank": "Add a bank account (SEPA)",
    "dash.iban": "IBAN",
    "dash.bankName": "Bank name",
    "dash.bic": "BIC / SWIFT",
    "dash.addBankBtn": "Submit bank account",
    "dash.addWallet": "Add a crypto wallet",
    "dash.walletAsset": "Asset",
    "dash.walletNetwork": "Network",
    "dash.walletAddress": "Wallet address",
    "dash.walletLabel": "Label (optional)",
    "dash.addWalletBtn": "Submit wallet",
    "dash.myFunding": "My funding methods",
    "dash.fundingNote":
      "Funding methods are reviewed by the UCP desk. A pending badge remains until administrative validation.",
    "dash.bankAdded": "Bank account submitted — pending validation",
    "dash.walletAdded": "Wallet submitted — pending validation",
    "dash.noTrades": "No trades yet.",
    "dash.noFunding": "No funding method submitted yet.",
    "dash.historyNote": "Your complete movement history, as recorded and managed by the UCP desk.",
    "dash.time": "Date",
    "dash.symbol": "Pair",
    "dash.side": "Side",
    "dash.price": "Price",
    "dash.quantity": "Quantity",
    "dash.status": "Status",
    "dash.note": "Note",
    "dash.by": "Origin",
    "dash.byDesk": "UCP Desk",
    "dash.byMe": "Me",
    "admin.title": "UCP Control Desk",
    "admin.loginTitle": "Restricted Access",
    "admin.loginSubtitle": "Administrative console — authorised personnel only.",
    "admin.overview": "Overview",
    "admin.clients": "Clients",
    "admin.trades": "Trades",
    "admin.funding": "Funding",
    "admin.logs": "Connection Logs",
    "admin.totalClients": "Total clients",
    "admin.pendingClients": "Pending validation",
    "admin.activeClients": "Active clients",
    "admin.pendingTrades": "Pending trades",
    "admin.pendingFunding": "Pending funding",
    "admin.totalUsd": "Client cash (USD)",
    "admin.connections": "Logged connections",
    "admin.approve": "Approve",
    "admin.reject": "Reject",
    "admin.suspend": "Suspend",
    "admin.reactivate": "Reactivate",
    "admin.addClient": "Add client",
    "admin.adjustBalance": "Adjust balance",
    "admin.asset": "Asset",
    "admin.mode": "Mode",
    "admin.add": "Add",
    "admin.set": "Set",
    "admin.amount": "Amount",
    "admin.newTrade": "Simulate trade",
    "admin.client": "Client",
    "admin.registeredAt": "Registered",
    "admin.ip": "IP address",
    "admin.actions": "Actions",
    "admin.edit": "Edit",
    "admin.delete": "Delete",
    "admin.validate": "Validate",
    "admin.userAgent": "User agent",
    "admin.when": "Timestamp",
    "admin.type": "Type",
    "admin.details": "Details",
    "admin.balanceUpdated": "Balance updated",
    "admin.statusUpdated": "Status updated",
    "admin.tradeSaved": "Trade saved",
    "admin.tradeDeleted": "Trade deleted",
    "admin.clientCreated": "Client created",
    "how.eyebrow": "How it works",
    "how.title": "From application to execution in three steps",
    "how.step1t": "1 · Apply",
    "how.step1d": "Submit your registration with email, full name and phone. Every application is personally reviewed by the UCP desk.",
    "how.step2t": "2 · Fund",
    "how.step2d": "Register your SEPA bank account (IBAN, bank, BIC/SWIFT) or crypto wallet (asset + network). Each funding method is validated by the desk.",
    "how.step3t": "3 · Trade",
    "how.step3d": "Once validated, access your full terminal: live Binance prices, professional charts and desk-supervised execution.",
    "sec.eyebrow": "Security & Custody",
    "sec.title": "Bank-grade protection at every layer",
    "sec.body": "Your credentials, sessions and funding data are protected by institutional-grade controls.",
    "sec.p1": "Bcrypt-hashed credentials",
    "sec.p1d": "Passwords are hashed with per-user salts — never stored in plain text.",
    "sec.p2": "Encrypted sessions",
    "sec.p2d": "httpOnly secure cookies with short-lived access tokens and automatic refresh.",
    "sec.p3": "Full connection audit",
    "sec.p3d": "Every login is logged with timestamp, IP address and device fingerprint.",
    "sec.stat1": "Cold storage coverage",
    "sec.stat2": "Desk-validated transactions",
    "sec.stat3": "Connection audit trail",
    "faq.eyebrow": "FAQ",
    "faq.title": "Frequently asked questions",
    "faq.q1": "Are the prices on UCP real?",
    "faq.a1": "Yes. All quotes are streamed live from Binance public market data — the same prices you see on the exchange, updated in real time.",
    "faq.q2": "Is my money actually traded?",
    "faq.a2": "UCP is a simulated institutional environment. Executions, balances and history are managed by the UCP desk to replicate real trading conditions.",
    "faq.q3": "Why does my account need validation?",
    "faq.a3": "Every registration is reviewed by our desk. Your full dashboard unlocks once your profile is approved — this is how we keep the client circle private.",
    "faq.q4": "What is the DCA strategy?",
    "faq.a4": "Dollar Cost Averaging invests a fixed amount at regular intervals, mathematically lowering your average entry price compared to one-off timing.",
    "faq.q5": "Which funding methods are supported?",
    "faq.a5": "SEPA bank transfers (IBAN/BIC) and crypto wallets across networks such as Base, ERC-20, TRC-20, BEP-20, Solana and Bitcoin — all desk-validated.",
    "dash.markets": "Markets",
    "admin.editClient": "Edit client",
    "admin.newPassword": "New password (leave blank to keep current)",
    "admin.clientUpdated": "Client updated",
    "chart.indicators": "Indicators",
    "nav.services": "Services",
    "nav.news": "News",
    "nav.contact": "Contact",
    "contact.title": "Contact the desk",
    "contact.subtitle": "Write to us — your message lands directly with our team. All fields are required.",
    "contact.firstName": "First name",
    "contact.lastName": "Last name",
    "contact.phone": "Phone number",
    "contact.email": "Email address",
    "contact.message": "Your message",
    "contact.send": "Send message",
    "contact.success": "Message sent — our team will get back to you shortly.",
    "news.eyebrow": "Newsroom",
    "news.title": "UCP News & Market Briefings",
    "news.subtitle": "Analyses, product updates and market insights published by the UCP desk.",
    "news.empty": "No publication yet — the desk is preparing the first briefing.",
    "news.readMore": "Read",
    "chat.title": "UCP Desk — Live chat",
    "chat.open": "Chat with the desk",
    "chat.placeholder": "Write your message…",
    "chat.autoReply": "Thank you for your message. Please hold on — an operator will be with you shortly.",
    "chat.attach": "Attach a file",
    "chat.edited": "(edited)",
    "notif.title": "Notifications",
    "notif.empty": "No notification yet.",
    "wallet.tab": "Wallet",
    "kyc.tab": "Identity",
    "docs.tab": "Documents",
    "fiscal.tab": "Fiscal & Offshore",
    "wallet.title": "Wallet — Deposits & Withdrawals",
    "wallet.subtitle": "Initiate a bank or crypto funding request. Every request is reviewed and validated by the UCP desk.",
    "wallet.deposit": "Deposit",
    "wallet.withdraw": "Withdrawal",
    "wallet.method": "Method",
    "wallet.bank": "Bank transfer (SEPA)",
    "wallet.crypto": "Crypto network",
    "wallet.asset": "Asset",
    "wallet.amount": "Amount",
    "wallet.details": "Details",
    "wallet.detailsHintBank": "Reference / IBAN used for the transfer…",
    "wallet.detailsHintCrypto": "Network, transaction hash or destination wallet…",
    "wallet.submit": "Submit request",
    "wallet.history": "My requests",
    "wallet.empty": "No request yet.",
    "wallet.approved": "Approved",
    "wallet.rejected": "Rejected",
    "wallet.submitted": "Request submitted — pending desk validation",
    "kyc.title": "Identity verification",
    "kyc.subtitle": "Upload a high-quality scan (PDF or image) of your ID card or passport. Selfie verification is not required at this stage.",
    "kyc.identity": "ID card / Passport",
    "kyc.upload": "Upload document",
    "kyc.uploaded": "Document received — pending desk review",
    "kyc.hint": "PDF, JPG or PNG — max 4 MB, good quality required.",
    "docs.title": "Documents vault",
    "docs.subtitle": "Securely deposit your sensitive documents: tax forms, bank details (RIB), proof of address, invoices…",
    "docs.fiscal": "Tax document",
    "docs.rib": "Bank details (RIB)",
    "docs.domicile": "Proof of address",
    "docs.invoice": "Invoice",
    "docs.other": "Other",
    "docs.upload": "Deposit document",
    "docs.empty": "No document deposited yet.",
    "docs.uploaded": "Document deposited — pending desk review",
    "fiscal.title": "Tax optimisation & Extraterritoriality",
    "fiscal.subtitle": "Fiscal optimisation for 100% crypto numbered accounts, with foreign withdrawal opening for our clients.",
    "fiscal.requestBtn": "Request activation of this service",
    "fiscal.motivation": "Describe your situation and objectives (optional)",
    "fiscal.requested": "Your request is being reviewed by the desk. This space will unlock upon acceptance.",
    "fiscal.rejected": "Your request was not approved. Please contact the desk for more information.",
    "fiscal.activeIntro": "Your fiscal space is active. Complete the relevant sections below — each submission is reviewed individually by the desk.",
    "fiscal.tab1": "Foreign account opening",
    "fiscal.tab2": "Numbered crypto account",
    "fiscal.tab3": "Optimised foreign withdrawals",
    "fiscal.contentLabel": "Your submission — free text (situation, available documents, objectives…)",
    "fiscal.submit": "Submit for review",
    "fiscal.submitted": "Submission received — pending review",
    "fiscal.mySubmissions": "My submissions",
    "admin.crm": "CRM",
    "admin.inbox": "Inbox",
    "admin.chat": "Chat",
    "admin.notificationsTab": "Notifications",
    "admin.documents": "Documents",
    "admin.transactions": "Transactions",
    "admin.fiscalTab": "Fiscal",
    "admin.news": "News",
    "admin.leads": "Leads (first contact)",
    "admin.firstContact": "First contact",
    "admin.existingClient": "Existing client",
    "admin.reply": "Reply",
    "admin.editMessage": "Edit message",
    "admin.sendNotification": "Send notification",
    "admin.notifTitle": "Title",
    "admin.notifBody": "Message",
    "admin.selectClient": "Select a client",
    "admin.publish": "Publish",
    "admin.newsTitle": "New publication",
    "admin.image": "Image (optional)",
    "admin.newsEmpty": "No publication yet.",
    "admin.noConversations": "No conversation yet.",
    "admin.typeMessage": "Write a reply…",
    "admin.download": "Download",
    "admin.source": "Source",
    "admin.totalValue": "Value",
    "admin.messages": "Messages",
    "admin.submissions": "Submissions",
    "admin.requests": "Requests",
    "admin.motivation": "Motivation",
    "admin.content": "Content",
    "admin.activate": "Activate",
    "admin.markRead": "Mark as read",
    "admin.tab": "Section",
    "newsletter.eyebrow": "Stay informed",
    "newsletter.title": "The UCP market briefing",
    "newsletter.subtitle":
      "One concise institutional briefing every week: crypto market structure, strategy notes and desk insights. No spam — unsubscribe anytime.",
    "newsletter.placeholder": "Your email address",
    "newsletter.button": "Subscribe",
    "newsletter.success": "Welcome aboard — your first briefing arrives this week.",
    "academy.eyebrow": "Trading Academy",
    "academy.title": "Professional market education",
    "academy.subtitle": "The same analytical frameworks our desk applies — explained clearly.",
    "academy.read": "Read the analysis",
    "academy.a1t": "Moving averages: the trader's compass",
    "academy.a1lead": "How professionals use SMA & EMA to read trend direction, time entries and manage exits.",
    "academy.a1p1": "A moving average smooths price action over N periods. The SMA (Simple Moving Average) weights every close equally; the EMA (Exponential Moving Average) gives more weight to recent prices and reacts faster — a decisive edge on volatile assets like crypto.",
    "academy.a1p2": "The 50/200 crossover is the most watched institutional signal: a Golden Cross (MA50 crossing above MA200) marks long-term bullish momentum; a Death Cross (MA50 below MA200) warns of a bearish regime. On Bitcoin, these crosses have historically preceded the major trend phases.",
    "academy.a1p3": "In trending markets, the 20-period MA acts as dynamic support in uptrends and dynamic resistance in downtrends. Professionals combine three filters: price position versus the average, the slope of the average, and the distance between averages (trend strength).",
    "academy.a1b1": "Golden Cross / Death Cross: the 50/200 regime filter",
    "academy.a1b2": "EMA 20 for timing, SMA 200 for regime",
    "academy.a1b3": "Flat averages = range: stand aside or trade the edges",
    "academy.a2t": "RSI & momentum: measuring the market's pulse",
    "academy.a2lead": "Spot exhaustion before the crowd with the Relative Strength Index.",
    "academy.a2p1": "The RSI oscillates between 0 and 100. Above 70 the asset is statistically overbought; below 30, oversold. In strong trends these zones can persist for weeks — the real edge comes from divergences.",
    "academy.a2p2": "A bearish divergence — price prints a higher high while RSI prints a lower high — signals fading momentum and often precedes a reversal. Bullish divergences work symmetrically at market lows.",
    "academy.a2p3": "Best practice: use RSI in the direction of the dominant trend. In an uptrend, buy oversold pullbacks (RSI 35-45); in a downtrend, sell overbought rebounds. Momentum confirms the moving-average framework — it never replaces it.",
    "academy.a2b1": "Divergences beat raw overbought/oversold levels",
    "academy.a2b2": "RSI 40-50 = classic pullback buy zone in bull trends",
    "academy.a2b3": "Always confirm with the trend filter (MA 200)",
    "academy.a3t": "Risk management: the mathematics of survival",
    "academy.a3lead": "Position sizing and drawdown control — what separates professionals from gamblers.",
    "academy.a3p1": "Rule #1: never risk more than 1-2% of capital on a single trade. With 1% risk, a streak of 10 consecutive losses — statistically normal — only costs 10% of the portfolio and keeps you in the game.",
    "academy.a3p2": "Position size = (capital × risk%) ÷ stop distance. The stop-loss belongs beyond market structure (below a support, outside a Bollinger band) — never at a round number where order clusters get hunted.",
    "academy.a3p3": "Demand a minimum 2:1 reward-to-risk ratio: with a 40% win rate, 2:1 trades are already profitable over the long run ((0.4 × 2) − (0.6 × 1) = +0.2 per unit risked). Discipline compounds.",
    "academy.a3b1": "1-2% maximum risk per position",
    "academy.a3b2": "Stop beyond structure, size from the stop",
    "academy.a3b3": "Minimum 2:1 reward-to-risk ratio",
    "common.loading": "Loading…",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.close": "Close",
    "common.delete": "Delete",
  },
  fr: {
    "nav.solutions": "Solutions",
    "nav.markets": "Marchés",
    "nav.about": "À propos",
    "nav.login": "Espace Client",
    "nav.openAccount": "Ouvrir un compte",
    "nav.dashboard": "Mon tableau de bord",
    "hero.badge": "Gestion privée crypto · Desk d'exécution institutionnel",
    "hero.titleA": "La gestion privée crypto,",
    "hero.titleB": "pensée comme une institution.",
    "hero.subtitle":
      "UCP allie la discipline de la banque privée suisse à l'exécution en temps réel sur actifs numériques. Données de marché Binance en direct, supervision par un desk dédié et stratégies d'accumulation sur mesure — dans un espace client confidentiel.",
    "hero.ctaPrimary": "Demander l'accès",
    "hero.ctaSecondary": "Découvrir nos solutions",
    "hero.liveLabel": "Flux de marché en direct",
    "trust.aum": "Actifs sous conseil",
    "trust.uptime": "Disponibilité des données",
    "trust.cold": "Couverture cold storage",
    "trust.clients": "Clients privés accompagnés",
    "solutions.eyebrow": "Solutions d'investissement",
    "solutions.title": "Des stratégies conçues pour les actifs numériques",
    "solutions.subtitle":
      "Inspirées de la construction de portefeuille en banque privée, adaptées aux marchés crypto. Chaque mandat est exécuté et supervisé par le desk UCP.",
    "solutions.dca.title": "Accumulation DCA",
    "solutions.dca.desc":
      "Le Dollar Cost Averaging lisse le prix d'entrée en investissant des montants fixes à intervalles réguliers — quelle que soit la direction du marché.",
    "solutions.dca.b1": "Allocations programmées hebdomadaires ou mensuelles",
    "solutions.dca.b2": "Exécution automatique sur BTC, ETH et stablecoins",
    "solutions.dca.b3": "Récolte de volatilité : plus d'unités achetées quand les prix baissent",
    "solutions.yield.title": "Génération de rendement",
    "solutions.yield.desc":
      "Stratégies de trésorerie en stablecoins visant un rendement régulier, avec contrôles stricts de contrepartie et de réseau.",
    "solutions.yield.b1": "Positions de carry structurées USDT / USDC",
    "solutions.yield.b2": "Règlement multi-réseaux (Base, ERC-20, TRC-20)",
    "solutions.yield.b3": "Reporting mensuel avec piste d'audit complète",
    "solutions.arb.title": "Arbitrage haute fréquence",
    "solutions.arb.desc":
      "Capture des dislocations de prix entre plateformes par notre infrastructure d'exécution, surveillée 24h/24.",
    "solutions.arb.b1": "Détection de spreads en moins d'une seconde",
    "solutions.arb.b2": "Exposition delta-neutre — aucun risque directionnel",
    "solutions.arb.b3": "Règlement validé par le desk à chaque cycle",
    "solutions.wealth.title": "Mandats de gestion sur mesure",
    "solutions.wealth.desc":
      "Un conseiller dédié construit une allocation d'actifs numériques sur mesure, alignée avec vos objectifs patrimoniaux globaux.",
    "solutions.wealth.b1": "Mandats discrétionnaires ou consultatifs",
    "solutions.wealth.b2": "Rails de financement SEPA & multi-réseaux",
    "solutions.wealth.b3": "Revue trimestrielle confidentielle",
    "math.eyebrow": "Les mathématiques du DCA",
    "math.title": "Pourquoi l'accumulation disciplinée bat le timing",
    "math.formulaLabel": "Coût moyen d'acquisition",
    "math.formula": "P̄ = Σ Aᵢ / Σ (Aᵢ / Pᵢ)",
    "math.formulaHint":
      "Où Aᵢ est le montant investi à la période i et Pᵢ le prix de marché. La moyenne harmonique des prix fait que vous achetez automatiquement plus d'unités quand les prix sont bas.",
    "math.exampleTitle": "Illustration — 1 000 $ par mois pendant 4 mois",
    "math.colMonth": "Mois",
    "math.colPrice": "Prix du BTC",
    "math.colUnits": "Unités acquises",
    "math.avg": "Votre coût moyen",
    "math.last": "Dernier prix",
    "math.result":
      "Le coût moyen se situe sous la moyenne arithmétique des prix — l'avantage mathématique du DCA.",
    "markets.eyebrow": "Marchés en direct",
    "markets.title": "Prix en temps réel, directement depuis Binance",
    "markets.subtitle": "Cotations en streaming sur les 10 actifs numériques les plus échangés.",
    "markets.asset": "Actif",
    "markets.price": "Prix",
    "markets.change": "Variation 24h",
    "markets.high": "Plus haut 24h",
    "markets.low": "Plus bas 24h",
    "markets.volume": "Volume (USDT)",
    "about.eyebrow": "Le standard UCP",
    "about.title": "La rigueur de la banque privée, l'exécution crypto-native",
    "about.body":
      "Chaque relation client est supervisée par le desk UCP. Dépôts, retraits et trades sont examinés et validés individuellement — alliant les processus de conformité institutionnels à la vitesse des actifs numériques.",
    "about.point1": "Transactions validées par le desk",
    "about.point1d": "Aucun mouvement n'est exécuté sans validation administrative.",
    "about.point2": "Espace client confidentiel",
    "about.point2d": "L'accès n'est accordé qu'après examen du dossier par notre équipe.",
    "about.point3": "Reporting institutionnel",
    "about.point3d": "Historique complet des trades, journal des connexions et exports.",
    "cta.title": "Ouvrez votre espace client privé",
    "cta.subtitle":
      "Chaque inscription est examinée par le desk UCP. Une fois validée, votre environnement de trading complet est débloqué.",
    "cta.button": "Créer mon compte",
    "footer.tagline":
      "Gestion de fortune privée et exécution d'actifs numériques de niveau institutionnel, réservée à un cercle confidentiel de clients.",
    "footer.legalTitle": "Mentions légales",
    "footer.contactTitle": "Contact",
    "footer.cgv": "Conditions Générales de Vente",
    "footer.cgu": "Conditions Générales d'Utilisation",
    "footer.privacy": "Politique de confidentialité & RGPD",
    "footer.cookies": "Politique de cookies",
    "footer.rights": "Tous droits réservés.",
    "cookies.title": "Votre vie privée compte",
    "cookies.body":
      "Nous utilisons des cookies essentiels pour l'authentification et la sécurité, et des cookies optionnels pour améliorer votre expérience. Vous pouvez accepter ou refuser les cookies non essentiels.",
    "cookies.accept": "Tout accepter",
    "cookies.decline": "Essentiels uniquement",
    "cookies.learn": "En savoir plus",
    "auth.loginTitle": "Connexion Client",
    "auth.loginSubtitle": "Accédez à votre espace de trading privé.",
    "auth.identifier": "Email ou identifiant",
    "auth.password": "Mot de passe",
    "auth.loginBtn": "Se connecter",
    "auth.noAccount": "Pas encore de compte ?",
    "auth.createOne": "Demander l'accès",
    "auth.registerTitle": "Ouvrir un compte",
    "auth.registerSubtitle":
      "Votre inscription sera examinée par le desk UCP avant l'ouverture de l'accès complet.",
    "auth.fullName": "Nom complet",
    "auth.email": "Adresse email",
    "auth.phone": "Numéro de téléphone",
    "auth.confirm": "Confirmer le mot de passe",
    "auth.registerBtn": "Soumettre ma demande",
    "auth.hasAccount": "Déjà inscrit ?",
    "auth.acceptCgu": "J'accepte les CGU et la Politique de confidentialité",
    "auth.pendingTitle": "Demande en cours d'examen",
    "auth.pendingBody":
      "Merci. Votre inscription est en cours d'examen par le desk UCP. Vous recevrez l'accès à votre tableau de bord complet dès validation de votre compte.",
    "auth.mismatch": "Les mots de passe ne correspondent pas",
    "auth.mustAccept": "Veuillez accepter les CGU",
    "dash.overview": "Vue d'ensemble",
    "dash.trading": "Trading",
    "dash.funding": "Financements & Wallets",
    "dash.history": "Historique",
    "dash.totalValue": "Valeur totale du portefeuille",
    "dash.cash": "Liquidités disponibles (USD)",
    "dash.btcEq": "Équivalent BTC",
    "dash.logout": "Se déconnecter",
    "dash.pendingGateTitle": "Compte en attente de validation",
    "dash.pendingGateBody":
      "Votre demande a bien été reçue. Le desk UCP examine votre profil — votre tableau de bord complet se débloquera dès validation. Aucune action n'est requise de votre part.",
    "dash.rejectedGateTitle": "Demande non approuvée",
    "dash.rejectedGateBody":
      "Votre demande n'a pas pu être approuvée pour le moment. Veuillez contacter le desk pour plus d'informations.",
    "dash.suspendedGateTitle": "Compte suspendu",
    "dash.suspendedGateBody": "Votre compte est temporairement suspendu. Veuillez contacter le desk UCP.",
    "dash.tradeTicket": "Ticket d'ordre",
    "dash.buy": "Acheter",
    "dash.sell": "Vendre",
    "dash.amount": "Montant (USD)",
    "dash.submitTrade": "Soumettre l'ordre",
    "dash.tradeSent": "Ordre soumis — en attente de validation du desk",
    "dash.pendingBadge": "En attente",
    "dash.executedBadge": "Exécuté",
    "dash.rejectedBadge": "Rejeté",
    "dash.validatedBadge": "Validé",
    "dash.recentTrades": "Historique des trades",
    "dash.allocTitle": "Allocation des actifs",
    "dash.addBank": "Ajouter un compte bancaire (SEPA)",
    "dash.iban": "IBAN",
    "dash.bankName": "Nom de la banque",
    "dash.bic": "BIC / SWIFT",
    "dash.addBankBtn": "Soumettre le compte",
    "dash.addWallet": "Ajouter un wallet crypto",
    "dash.walletAsset": "Actif",
    "dash.walletNetwork": "Réseau",
    "dash.walletAddress": "Adresse du wallet",
    "dash.walletLabel": "Libellé (optionnel)",
    "dash.addWalletBtn": "Soumettre le wallet",
    "dash.myFunding": "Mes moyens de financement",
    "dash.fundingNote":
      "Les moyens de financement sont examinés par le desk UCP. Un badge « en attente » reste affiché jusqu'à validation administrative.",
    "dash.bankAdded": "Compte bancaire soumis — en attente de validation",
    "dash.walletAdded": "Wallet soumis — en attente de validation",
    "dash.noTrades": "Aucun trade pour le moment.",
    "dash.noFunding": "Aucun moyen de financement soumis.",
    "dash.historyNote": "Votre historique complet des mouvements, tel qu'enregistré et géré par le desk UCP.",
    "dash.time": "Date",
    "dash.symbol": "Paire",
    "dash.side": "Sens",
    "dash.price": "Prix",
    "dash.quantity": "Quantité",
    "dash.status": "Statut",
    "dash.note": "Note",
    "dash.by": "Origine",
    "dash.byDesk": "Desk UCP",
    "dash.byMe": "Moi",
    "admin.title": "Desk de contrôle UCP",
    "admin.loginTitle": "Accès restreint",
    "admin.loginSubtitle": "Console administrative — personnel autorisé uniquement.",
    "admin.overview": "Vue d'ensemble",
    "admin.clients": "Clients",
    "admin.trades": "Trades",
    "admin.funding": "Financements",
    "admin.logs": "Journaux de connexion",
    "admin.totalClients": "Clients totaux",
    "admin.pendingClients": "En attente de validation",
    "admin.activeClients": "Clients actifs",
    "admin.pendingTrades": "Trades en attente",
    "admin.pendingFunding": "Financements en attente",
    "admin.totalUsd": "Liquidités clients (USD)",
    "admin.connections": "Connexions enregistrées",
    "admin.approve": "Approuver",
    "admin.reject": "Rejeter",
    "admin.suspend": "Suspendre",
    "admin.reactivate": "Réactiver",
    "admin.addClient": "Ajouter un client",
    "admin.adjustBalance": "Ajuster le solde",
    "admin.asset": "Actif",
    "admin.mode": "Mode",
    "admin.add": "Ajouter",
    "admin.set": "Définir",
    "admin.amount": "Montant",
    "admin.newTrade": "Simuler un trade",
    "admin.client": "Client",
    "admin.registeredAt": "Inscrit le",
    "admin.ip": "Adresse IP",
    "admin.actions": "Actions",
    "admin.edit": "Modifier",
    "admin.delete": "Supprimer",
    "admin.validate": "Valider",
    "admin.userAgent": "Agent utilisateur",
    "admin.when": "Horodatage",
    "admin.type": "Type",
    "admin.details": "Détails",
    "admin.balanceUpdated": "Solde mis à jour",
    "admin.statusUpdated": "Statut mis à jour",
    "admin.tradeSaved": "Trade enregistré",
    "admin.tradeDeleted": "Trade supprimé",
    "admin.clientCreated": "Client créé",
    "how.eyebrow": "Comment ça marche",
    "how.title": "De la demande d'accès à l'exécution, en trois étapes",
    "how.step1t": "1 · Candidatez",
    "how.step1d": "Soumettez votre inscription avec email, nom complet et téléphone. Chaque demande est examinée personnellement par le desk UCP.",
    "how.step2t": "2 · Alimentez",
    "how.step2d": "Enregistrez votre compte bancaire SEPA (IBAN, banque, BIC/SWIFT) ou votre wallet crypto (actif + réseau). Chaque moyen de financement est validé par le desk.",
    "how.step3t": "3 · Tradez",
    "how.step3d": "Une fois validé, accédez à votre terminal complet : prix Binance en direct, graphiques professionnels et exécution supervisée par le desk.",
    "sec.eyebrow": "Sécurité & Conservation",
    "sec.title": "Une protection bancaire à chaque couche",
    "sec.body": "Vos identifiants, sessions et données de financement sont protégés par des contrôles de niveau institutionnel.",
    "sec.p1": "Identifiants hachés bcrypt",
    "sec.p1d": "Les mots de passe sont hachés avec un sel unique par utilisateur — jamais stockés en clair.",
    "sec.p2": "Sessions chiffrées",
    "sec.p2d": "Cookies httpOnly sécurisés, jetons d'accès à durée courte et rafraîchissement automatique.",
    "sec.p3": "Audit complet des connexions",
    "sec.p3d": "Chaque connexion est journalisée avec horodatage, adresse IP et empreinte de l'appareil.",
    "sec.stat1": "Couverture cold storage",
    "sec.stat2": "Transactions validées par le desk",
    "sec.stat3": "Piste d'audit des connexions",
    "faq.eyebrow": "FAQ",
    "faq.title": "Questions fréquentes",
    "faq.q1": "Les prix affichés sur UCP sont-ils réels ?",
    "faq.a1": "Oui. Toutes les cotations sont diffusées en direct depuis les données de marché publiques de Binance — les mêmes prix que sur l'exchange, actualisés en temps réel.",
    "faq.q2": "Mon argent est-il réellement tradé ?",
    "faq.a2": "UCP est un environnement institutionnel simulé. Les exécutions, soldes et historiques sont gérés par le desk UCP pour reproduire des conditions de trading réelles.",
    "faq.q3": "Pourquoi mon compte doit-il être validé ?",
    "faq.a3": "Chaque inscription est examinée par notre desk. Votre tableau de bord complet se débloque une fois votre profil approuvé — c'est ainsi que nous préservons la confidentialité du cercle client.",
    "faq.q4": "Qu'est-ce que la stratégie DCA ?",
    "faq.a4": "Le Dollar Cost Averaging investit un montant fixe à intervalles réguliers, abaissant mathématiquement votre prix d'entrée moyen par rapport à un achat unique.",
    "faq.q5": "Quels moyens de financement sont acceptés ?",
    "faq.a5": "Virements SEPA (IBAN/BIC) et wallets crypto sur les réseaux Base, ERC-20, TRC-20, BEP-20, Solana et Bitcoin — tous validés par le desk.",
    "dash.markets": "Marchés",
    "admin.editClient": "Modifier le client",
    "admin.newPassword": "Nouveau mot de passe (laisser vide pour conserver)",
    "admin.clientUpdated": "Client mis à jour",
    "chart.indicators": "Indicateurs",
    "nav.services": "Services",
    "nav.news": "Actualités",
    "nav.contact": "Contact",
    "contact.title": "Contacter le desk",
    "contact.subtitle": "Écrivez-nous — votre message arrive directement à notre équipe. Tous les champs sont obligatoires.",
    "contact.firstName": "Prénom",
    "contact.lastName": "Nom",
    "contact.phone": "Numéro de téléphone",
    "contact.email": "Adresse email",
    "contact.message": "Votre message",
    "contact.send": "Envoyer le message",
    "contact.success": "Message envoyé — notre équipe reviendra vers vous rapidement.",
    "news.eyebrow": "Newsroom",
    "news.title": "Actualités & analyses UCP",
    "news.subtitle": "Analyses, nouveautés produits et perspectives de marché publiées par le desk UCP.",
    "news.empty": "Aucune publication pour le moment — le desk prépare le premier briefing.",
    "news.readMore": "Lire",
    "chat.title": "Desk UCP — Chat en direct",
    "chat.open": "Discuter avec le desk",
    "chat.placeholder": "Écrivez votre message…",
    "chat.autoReply": "Merci pour votre message. Veuillez patienter — un opérateur arrive dans un instant.",
    "chat.attach": "Joindre un fichier",
    "chat.edited": "(modifié)",
    "notif.title": "Notifications",
    "notif.empty": "Aucune notification pour le moment.",
    "wallet.tab": "Portefeuille",
    "kyc.tab": "Identité",
    "docs.tab": "Documents",
    "fiscal.tab": "Fiscalité",
    "wallet.title": "Portefeuille — Dépôts & Retraits",
    "wallet.subtitle": "Initiez une demande de dépôt ou de retrait bancaire / crypto. Chaque demande est examinée et validée par le desk UCP.",
    "wallet.deposit": "Dépôt",
    "wallet.withdraw": "Retrait",
    "wallet.method": "Méthode",
    "wallet.bank": "Virement bancaire (SEPA)",
    "wallet.crypto": "Réseau crypto",
    "wallet.asset": "Actif",
    "wallet.amount": "Montant",
    "wallet.details": "Détails",
    "wallet.detailsHintBank": "Référence / IBAN utilisé pour le virement…",
    "wallet.detailsHintCrypto": "Réseau, hash de transaction ou wallet de destination…",
    "wallet.submit": "Soumettre la demande",
    "wallet.history": "Mes demandes",
    "wallet.empty": "Aucune demande pour le moment.",
    "wallet.approved": "Approuvée",
    "wallet.rejected": "Rejetée",
    "wallet.submitted": "Demande soumise — en attente de validation du desk",
    "kyc.title": "Vérification d'identité",
    "kyc.subtitle": "Téléversez un scan de bonne qualité (PDF ou image) de votre carte d'identité ou passeport. La vérification selfie n'est pas requise à ce stade.",
    "kyc.identity": "Carte d'identité / Passeport",
    "kyc.upload": "Téléverser le document",
    "kyc.uploaded": "Document reçu — en cours d'examen par le desk",
    "kyc.hint": "PDF, JPG ou PNG — 4 Mo max, bonne qualité exigée.",
    "docs.title": "Coffre-fort documentaire",
    "docs.subtitle": "Déposez en toute sécurité vos documents sensibles : formulaires fiscaux, RIB, justificatif de domicile, factures…",
    "docs.fiscal": "Document fiscal",
    "docs.rib": "Relevé d'identité bancaire (RIB)",
    "docs.domicile": "Justificatif de domicile",
    "docs.invoice": "Facture",
    "docs.other": "Autre",
    "docs.upload": "Déposer le document",
    "docs.empty": "Aucun document déposé pour le moment.",
    "docs.uploaded": "Document déposé — en cours d'examen par le desk",
    "fiscal.title": "Fiscalité & Extraterritorialité",
    "fiscal.subtitle": "Optimisation fiscale pour comptes numérotés 100 % cryptomonnaies, avec ouverture de retraits à l'étranger pour nos clients.",
    "fiscal.requestBtn": "Demander l'activation de ce service",
    "fiscal.motivation": "Décrivez votre situation et vos objectifs (optionnel)",
    "fiscal.requested": "Votre demande est en cours d'examen par le desk. Cet espace se débloquera dès acceptation.",
    "fiscal.rejected": "Votre demande n'a pas été approuvée. Veuillez contacter le desk pour plus d'informations.",
    "fiscal.activeIntro": "Votre espace fiscal est actif. Complétez les rubriques ci-dessous — chaque soumission est examinée individuellement par le desk.",
    "fiscal.tab1": "Ouverture de compte à l'étranger",
    "fiscal.tab2": "Compte numéroté crypto",
    "fiscal.tab3": "Retraits à l'étranger optimisés",
    "fiscal.contentLabel": "Votre soumission — champ libre (situation, documents disponibles, objectifs…)",
    "fiscal.submit": "Soumettre pour examen",
    "fiscal.submitted": "Soumission reçue — en cours d'examen",
    "fiscal.mySubmissions": "Mes soumissions",
    "admin.crm": "CRM",
    "admin.inbox": "Messagerie",
    "admin.chat": "Chat",
    "admin.notificationsTab": "Notifications",
    "admin.documents": "Documents",
    "admin.transactions": "Transactions",
    "admin.fiscalTab": "Fiscalité",
    "admin.news": "Actualités",
    "admin.leads": "Leads (premier contact)",
    "admin.firstContact": "Premier contact",
    "admin.existingClient": "Client existant",
    "admin.reply": "Répondre",
    "admin.editMessage": "Modifier le message",
    "admin.sendNotification": "Envoyer la notification",
    "admin.notifTitle": "Titre",
    "admin.notifBody": "Message",
    "admin.selectClient": "Sélectionner un client",
    "admin.publish": "Publier",
    "admin.newsTitle": "Nouvelle publication",
    "admin.image": "Image (optionnel)",
    "admin.newsEmpty": "Aucune publication pour le moment.",
    "admin.noConversations": "Aucune conversation pour le moment.",
    "admin.typeMessage": "Écrire une réponse…",
    "admin.download": "Télécharger",
    "admin.source": "Source",
    "admin.totalValue": "Valeur",
    "admin.messages": "Messages",
    "admin.submissions": "Soumissions",
    "admin.requests": "Demandes",
    "admin.motivation": "Motivation",
    "admin.content": "Contenu",
    "admin.activate": "Activer",
    "admin.markRead": "Marquer comme lu",
    "admin.tab": "Rubrique",
    "newsletter.eyebrow": "Restez informé",
    "newsletter.title": "La lettre de marché UCP",
    "newsletter.subtitle":
      "Un briefing institutionnel et concis chaque semaine : structure des marchés crypto, notes de stratégie et analyses du desk. Zéro spam — désinscription à tout moment.",
    "newsletter.placeholder": "Votre adresse email",
    "newsletter.button": "S'abonner",
    "newsletter.success": "Bienvenue — votre premier briefing arrive cette semaine.",
    "academy.eyebrow": "Académie Trading",
    "academy.title": "Une formation de marché professionnelle",
    "academy.subtitle": "Les mêmes cadres d'analyse que ceux appliqués par notre desk — expliqués clairement.",
    "academy.read": "Lire l'analyse",
    "academy.a1t": "Moyennes mobiles : la boussole du trader",
    "academy.a1lead": "Comment les professionnels utilisent les SMA & EMA pour lire la tendance, chronométrer les entrées et gérer les sorties.",
    "academy.a1p1": "Une moyenne mobile lisse l'action des prix sur N périodes. La SMA (moyenne simple) pondère chaque clôture également ; l'EMA (moyenne exponentielle) donne plus de poids aux prix récents et réagit plus vite — un avantage décisif sur des actifs volatils comme les cryptos.",
    "academy.a1p2": "Le croisement 50/200 est le signal institutionnel le plus suivi : un Golden Cross (MM50 passant au-dessus de la MM200) marque un momentum haussier de long terme ; un Death Cross (MM50 sous la MM200) avertit d'un régime baissier. Sur le Bitcoin, ces croisements ont historiquement précédé les grandes phases de tendance.",
    "academy.a1p3": "En marché directionnel, la MM20 agit comme support dynamique dans les tendances haussières et comme résistance dynamique dans les tendances baissières. Les professionnels combinent trois filtres : position du prix par rapport à la moyenne, pente de la moyenne, et écart entre les moyennes (force de la tendance).",
    "academy.a1b1": "Golden Cross / Death Cross : le filtre de régime 50/200",
    "academy.a1b2": "EMA 20 pour le timing, SMA 200 pour le régime",
    "academy.a1b3": "Moyennes plates = range : s'abstenir ou trader les bornes",
    "academy.a2t": "RSI & momentum : mesurer le pouls du marché",
    "academy.a2lead": "Repérez l'épuisement avant la foule grâce au Relative Strength Index.",
    "academy.a2p1": "Le RSI oscille entre 0 et 100. Au-dessus de 70, l'actif est statistiquement suracheté ; sous 30, survendu. Dans les tendances fortes, ces zones peuvent persister des semaines — le véritable avantage vient des divergences.",
    "academy.a2p2": "Une divergence baissière — le prix inscrit un sommet plus haut tandis que le RSI inscrit un sommet plus bas — signale un momentum qui s'épuise et précède souvent un retournement. Les divergences haussières fonctionnent symétriquement sur les creux.",
    "academy.a2p3": "Bonne pratique : utilisez le RSI dans le sens de la tendance dominante. En tendance haussière, achetez les replis survendus (RSI 35-45) ; en tendance baissière, vendez les rebonds surachetés. Le momentum confirme le cadre des moyennes mobiles — il ne le remplace jamais.",
    "academy.a2b1": "Les divergences battent les simples zones de surachat/survente",
    "academy.a2b2": "RSI 40-50 = zone classique d'achat sur repli en tendance haussière",
    "academy.a2b3": "Toujours confirmer avec le filtre de tendance (MM 200)",
    "academy.a3t": "Gestion du risque : les mathématiques de la survie",
    "academy.a3lead": "Dimensionnement des positions et contrôle du drawdown — ce qui sépare les professionnels des parieurs.",
    "academy.a3p1": "Règle n°1 : ne risquez jamais plus de 1 à 2 % du capital sur un seul trade. Avec 1 % de risque, une série de 10 pertes consécutives — statistiquement normale — ne coûte que 10 % du portefeuille et vous garde dans la partie.",
    "academy.a3p2": "Taille de position = (capital × % de risque) ÷ distance du stop. Le stop-loss se place au-delà de la structure de marché (sous un support, en dehors d'une bande de Bollinger) — jamais sur un chiffre rond où les clusters d'ordres se font chasser.",
    "academy.a3p3": "Exigez un ratio rendement/risque minimal de 2:1 : avec 40 % de trades gagnants, des trades en 2:1 sont déjà profitables sur le long terme ((0,4 × 2) − (0,6 × 1) = +0,2 par unité risquée). La discipline compose.",
    "academy.a3b1": "1-2 % de risque maximum par position",
    "academy.a3b2": "Stop au-delà de la structure, taille calculée depuis le stop",
    "academy.a3b3": "Ratio rendement/risque minimum de 2:1",
    "common.loading": "Chargement…",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.close": "Fermer",
    "common.delete": "Supprimer",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("ucp_lang");
    if (saved) return saved;
    return navigator.language?.toLowerCase().startsWith("fr") ? "fr" : "en";
  });

  const setLang = (l) => {
    localStorage.setItem("ucp_lang", l);
    setLangState(l);
  };

  const t = (key) => translations[lang]?.[key] ?? translations.en[key] ?? key;

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
